import { IDefineCommand } from 'core-ts-types';
import { MetaRankingBuilder } from './../builders/major_metaranking_builder';

angular
  .module('major-explorer-data')
  .service('loadMetaRankingCommand', ($http: ng.IHttpService, defineCommand: IDefineCommand) => {
    return defineCommand('loadMetaRankingCommand', (deferred: ng.IDeferred<any>) => {
      $http.get('/programpicker/student/metamajor/').then(
        ({ data }: { data: any }) => {
          deferred.resolve(new MetaRankingBuilder(data));
        },
        ({ data }) => {
          deferred.reject(data);
        }
      );
    });
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/commands/load_metaranking_command.ts